import PageContainer from '../components/ui/PageContainer'
import { EmptyState, LoadingState } from '../components/ui/States'
import { useAppData } from '../contexts/AppDataContext'
import EventInfoSection from '../components/EventInfoSection'
import { hasEventInfoContent } from '../components/eventInfo'

/**
 * Standalone "Event Info" destination — the welcome message, venue, travel,
 * dress code, FAQs, and key contacts from the admin Edit Event form. Reachable
 * via the toggleable "Event Info" nav item.
 */
export default function EventInfoPage() {
  const { event } = useAppData()

  if (!event) return <LoadingState />

  return (
    <PageContainer title="Event Info" subtitle={event.name}>
      {hasEventInfoContent(event) ? (
        <EventInfoSection event={event} />
      ) : (
        <EmptyState
          title="No event details yet"
          description="Venue, travel, and other details will appear here once added."
        />
      )}
    </PageContainer>
  )
}
